export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/evaluate/pennant/user/query`,
          data
        });
      },

      save(data) {
          return http.json({
              url: '/evaluate/pennant/user/save',
              data
          })
      },
      getInfo(data) {
          return http.json({
              url: `/evaluate/pennant/user/get?id=${data.id}`
          })
      },
      /**
       * 删除版本
       * @param data
       * @return {*}
       */
      delete(data) {
          return http.json({
              url: `/evaluate/pennant/user/delete?id=${data[0].id}`,
              data
          })
      },
      list(){
          return http.json({
              url: `/evaluate/pennant/user/list`,
          })
      },
      handleIsTop(data){
          return http.json({
            url: `/evaluate/pennant/user/update`,
            data
        })
      }
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/pennantUser.js